export const usePermissionMatch = (available: string = '', needed: string = ''): boolean => {
  if (!needed) return true;
  return available === needed || available === '*';
};
